var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "group-list"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("群組管理")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-1 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 群組列表 ")])]), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2 mb-xl-0"
  }, [_c('h6', {
    staticClass: "mb-0 mr-2 flex-shrink-0"
  }, [_vm._v("群組狀態")]), _c('AppMultiSelect', {
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "input": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1)]), _c('div', {
    staticClass: "\n            col-12 col-xl-6\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center\n          "
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exportGroups
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("下載群組清單 ")]), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋群組"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.groups,
      "fields": _vm.fields,
      "no-local-sorting": true
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.group_number) + " ")])];
      }
    }, {
      key: "cell(branch)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.branch ? data.item.branch.name : "") + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.branch ? data.item.branch.branch_code : "") + " ")])];
      }
    }, {
      key: "cell(picture_url)",
      fn: function fn(data) {
        return [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.picture_url,
            expression: "!!data.item.picture_url"
          }],
          attrs: {
            "rounded": "",
            "src": data.item.picture_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(_vm._s(_vm.statusEnum(data.item.status)))]), _c('div', [_vm._v(_vm._s(data.item.type ? data.item.type.name : ""))])];
      }
    }, {
      key: "cell(bot_leave_and_datetime)",
      fn: function fn(data) {
        return [_c('p', [_vm._v(" " + _vm._s(!!data.item.bot_join_datetime ? _vm.formatDate(data.item.bot_join_datetime) : "") + " ")]), _c('p', {
          directives: [{
            name: "b-popover",
            rawName: "v-b-popover.hover.bottomright",
            value: '如要繼續在此群組中使用團購功能，請先將機器人加回群組',
            expression: "\n              '如要繼續在此群組中使用團購功能，請先將機器人加回群組'\n            ",
            modifiers: {
              "hover": true,
              "bottomright": true
            }
          }],
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "id": "popover-target",
            "title": "\u6A5F\u5668\u4EBA\u5DF2\u65BC".concat(_vm.formatDate(data.item.bot_leave_datetime), "\u9000\u51FA\u7FA4\u7D44")
          }
        }, [_vm._v(" " + _vm._s(!!data.item.bot_leave_datetime ? _vm.formatDate(data.item.bot_leave_datetime) : "") + " ")])];
      }
    }, {
      key: "cell(updated_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.updated_at)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticStyle: {
            "margin-right": "10px"
          },
          on: {
            "click": function click($event) {
              return _vm.handleGroupCheck(data.item);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh fa-lg"
        })]), _c('b-button', {
          staticStyle: {
            "margin-right": "10px"
          },
          on: {
            "click": function click($event) {
              return _vm.handleGroupUrlQrcode(data.item);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-qrcode fa-lg"
        })]), _c('b-dropdown', {
          staticClass: "m-2",
          attrs: {
            "id": "dropdown-left",
            "text": "動作",
            "disabled": !_vm.isActionButtonEnabled
          }
        }, [_vm.checkPermission([_vm.consts.GROUP_VIEW_DETAIL]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'ConversationRecordList',
              params: {
                group_id: data.item.id
              }
            }
          }
        }, [_vm._v(" 查看7天內對話紀錄 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUP_VIEW_DETAIL]) ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'GroupCustomerList',
              params: {
                group_id: data.item.id
              }
            }
          }
        }, [_vm._v(" 查看群組用戶名單 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUP_EDIT_LINK]) ? _c('b-dropdown-item', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: 'modal-edit-group-url',
            expression: "'modal-edit-group-url'"
          }],
          on: {
            "click": function click($event) {
              return _vm.editGroupUrl(data.item);
            }
          }
        }, [_vm._v(" 編輯群組連結 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUP_EDIT_BRANCH]) ? _c('b-dropdown-item', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: 'modal-edit-group-branch',
            expression: "'modal-edit-group-branch'"
          }],
          on: {
            "click": function click($event) {
              return _vm.editGroupBranch(data.item);
            }
          }
        }, [_vm._v(" 編輯所屬分店 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUP_LEAVE]) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.handleLeaveGroup(data.item);
            }
          }
        }, [_vm._v(" 機器人退出群組 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.GROUP_DELETE_LOGS]) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.handleDeleteGroup(data.item);
            }
          }
        }, [_vm._v(" 刪除群組紀錄 ")]) : _vm._e()], 1)];
      }
    }, {
      key: "head(member_count)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "d-flex cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.handleSort('member_count');
            }
          }
        }, [_vm._v(" 人數 "), _c('sort-caret', {
          staticClass: "ml-2",
          attrs: {
            "status": _vm.sortBy === 'member_count' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "head(branch)",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('span', {
          staticClass: "d-flex cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.handleSort('branch_id');
            }
          }
        }, [_vm._v(" 所屬分店/代號 "), _c('sort-caret', {
          staticClass: "ml-2",
          attrs: {
            "status": _vm.sortBy === 'branch_id' ? _vm.sortDesc ? _vm.SORT_CARET_STATUS.DESC : _vm.SORT_CARET_STATUS.ASC : _vm.SORT_CARET_STATUS.INIT
          }
        })], 1)])];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-edit-group-branch",
      "title": "編輯所屬分店",
      "centered": ""
    },
    on: {
      "hidden": _vm.resetModal,
      "ok": _vm.handleEditGroupBranch
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消編輯 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認送出 ")])];
      }
    }])
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentGroup.name))]), _c('p', [_vm._v(" 請務必確認所選擇的分店正確，確認送出後將影響後台帳號可看到的團購列表 ")]), _c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleEditGroupBranch.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', [_c('b-form-select', {
    attrs: {
      "options": _vm.branches
    },
    model: {
      value: _vm.groupBranchId,
      callback: function callback($$v) {
        _vm.groupBranchId = $$v;
      },
      expression: "groupBranchId"
    }
  })], 1), _c('b-form-group', [_c('b-form-select', {
    attrs: {
      "options": _vm.groupTypes,
      "required": ""
    },
    model: {
      value: _vm.groupTypeId,
      callback: function callback($$v) {
        _vm.groupTypeId = $$v;
      },
      expression: "groupTypeId"
    }
  })], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-edit-group-url",
      "title": "編輯群組連結",
      "centered": ""
    },
    on: {
      "hidden": _vm.resetModal,
      "ok": _vm.handleEditGroupUrl
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消編輯 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認送出 ")])];
      }
    }])
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentGroup.name))]), _c('form', {
    ref: "form"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "id": "group-url-input",
      "placeholder": "https://line.me/R/ti/g/ ◯ ◯ ◯",
      "required": ""
    },
    model: {
      value: _vm.groupUrl,
      callback: function callback($$v) {
        _vm.groupUrl = $$v;
      },
      expression: "groupUrl"
    }
  })], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }